/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React from 'react'

export default function CriteriaHeaders({ViewOffer,setshowProducts,
    isActive,
    setsearchValue,
    selectedCriteria,
    setselectedCriteria}) {
    const {items} = ViewOffer;
    return (
        <div className="w-full flex mt-10 overflow-auto">
            <ul className="nav nav-pills flex border-2 border-[#E9EDF4] rounded-lg h-[57px] w-full" style={{overflowY: 'hidden',flexDirection: 'column', display:'-webkit-inline-box'}} id="pills-tabVertical" role="tablist">
                {
                    items.product_criterion.length>0 && items.product_criterion.map((item,i)=>(
                        <li key={item.CATEGORY_CONCAT_SEGS}className="nav-item flex-grow text-center sm:min-w-[25%] min-w-[60%] border-r-2 border-[#E9EDF4]" role="presentation">
                            <a href="javascript:void(0)"
                                onClick={()=>{
                                    setshowProducts(false)
                                    setselectedCriteria(i);
                                    setsearchValue(undefined)
                                }}
                                className={`relative nav-link block ${selectedCriteria===i ?'active':'inactive'} offer1 font-semibold text-[#555259] text-xs22 w-full rounded-tl-[5px] rounded-bl-[5px] rounded-none`} id="pill3" data-bs-toggle="pill" data-bs-target="#home3" role="tab" aria-controls="home3" aria-selected="true">
                                Criteria {i+1} {item.and_combination &&<span className="text-[#ED1C24]">*</span>}
                            </a>
                        </li>
                    ))
                }
                
            </ul>
        </div>
    )
}
